import { IconProps } from "../../models/Icon";

export function BankSlipIcon({ size = 20, color = "#000", opacity = "1" }: IconProps) {

  return (
    <svg width={size} height={size} opacity={opacity} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="4" width="3.15789" height="16" fill="#3D485C"/>
    <rect x="18.8418" y="4" width="3.15789" height="16" fill="#3D485C"/>
    <rect x="10.4219" y="4" width="1.05263" height="16" fill="#3D485C"/>
    <rect x="6.21094" y="4" width="2.10526" height="16" fill="#3D485C"/>
    <rect x="12.5254" y="4" width="4.21053" height="16" fill="#3D485C"/>
    </svg>
  )
}